import React from 'react';
import { haptic } from '../../utils/haptics';
import styles from './agentChat.module.css';

/**
 * THE CUSTOMER'S OWN BOOKINGS AND ORDERS, AS CARDS WITH WHAT CAN BE DONE (owner 10-23: "same for existing bookings
 * managing or orders"). The server reads them through the customer's own doors (signed in) and says what the business's
 * rules allow (`canMove`, `canCancel`); a change is the server's step (`move_appointment`, `cancel_appointment`,
 * `cancel_order`) and comes back as a sentence to approve. Add to calendar is the store's own .ics; Open goes to the
 * order's page.
 */
export function AppointmentCards({ appointments, onAct, onCalendar, busy = false, t }) {
  if (!appointments?.length) return null;
  return (
    <div className={styles.bookingCards} role="list">
      {appointments.map((a) => {
        const what = [a.services, a.when].filter(Boolean).join(', ');
        const pending = a.status === 'PENDING';
        return (
          <div key={a.id} role="listitem" className={styles.bookingCard} data-testid="agent-appointment-card">
            <div className={styles.bookingWhen}>{a.when}</div>
            <div className={styles.bookingWhat}>{[a.services, a.specialist].filter(Boolean).join(' · ')}</div>
            {pending ? <div className={styles.bookingPending}>{a.statusLabel || t('agent.waitingApproval', { defaultValue: 'Waiting for the business to approve' })}</div> : null}
            <div className={styles.bookingActions}>
              {a.canMove ? <button type="button" className={styles.linkButton} disabled={busy} onClick={() => onAct(t('agent.rescheduleThis', { defaultValue: 'Reschedule {{what}}', what }), { type: 'move_appointment', id: a.id })}>{t('agent.reschedule', { defaultValue: 'Reschedule' })}</button> : null}
              {a.canCancel ? <button type="button" className={styles.linkButton} disabled={busy} onClick={() => onAct(t('agent.cancelThis', { defaultValue: 'Cancel {{what}}', what }), { type: 'cancel_appointment', id: a.id })}>{t('agent.cancelAppointment', { defaultValue: 'Cancel' })}</button> : null}
              {a.startsAt && a.endsAt && onCalendar ? <button type="button" className={styles.linkButton} onClick={() => { haptic('selection'); onCalendar(a); }}>{t('agent.addToCalendar', { defaultValue: 'Add to calendar' })}</button> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function OrderCards({ orders, hrefFor, onOpen, onAct, busy = false, t }) {
  if (!orders?.length) return null;
  return (
    <div className={styles.bookingCards} role="list">
      {orders.map((o) => {
        const href = hrefFor(o.path || `/orders/${o.id}`);
        return (
          <div key={o.id} role="listitem" className={styles.bookingCard} data-testid="agent-order-card">
            <div className={styles.bookingWhen}>{t('agent.orderNumber', { defaultValue: 'Order {{number}}', number: o.number })}</div>
            <div className={styles.bookingWhat}>{[o.statusLabel, o.total].filter(Boolean).join(' · ')}</div>
            <div className={styles.bookingActions}>
              <a className={styles.linkButton} href={href} onClick={(e) => { if (onOpen) { e.preventDefault(); onOpen(href); } }}>{t('agent.openOrder', { defaultValue: 'Open' })}</a>
              {o.canCancel ? <button type="button" className={styles.linkButton} disabled={busy} onClick={() => onAct(t('agent.cancelOrderNumber', { defaultValue: 'Cancel order {{number}}', number: o.number }), { type: 'cancel_order', orderId: o.id })}>{t('agent.cancelOrder', { defaultValue: 'Cancel order' })}</button> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
